import { generateSlidesFromLink } from "../../api/link";
import { uploadHandler } from "../../api/upload";
import { INITIAL_SLIDE_STATE } from "../../constants/states";
import { setIdle, setLoading } from "../../store/common/appStateSlice";
import { setSlides } from "../../store/slides/slidesSlice";
import { showToast } from "../../utils/general";
import { getFromLocal } from "../../utils/localStorage";

export const handleLinkUpload =
  (link, slide, cb) => async (dispatch, getState) => {
    dispatch(setLoading());
    const response = await generateSlidesFromLink(link, slide);
    dispatch(setIdle());

    const choices = response?.data || [];
    if (!choices.length) {
      return showToast("Something went wrong.!", "", "danger");
    }

    const scriptsMap = choices.slice(0, slide || 1).map((script, index) => {
      return script.content.replace(`Slide ${index + 1}:`, "").trim();
    });

    const slides = await Promise.all(
      scriptsMap.map(async (item, index) => {
        return {
          ...INITIAL_SLIDE_STATE,
          label: `${index + 1}`,
          originalScript: item,
          script: item,
          voiceFile: item?.voiceFile,
          generatedVoice: item?.voiceFile,
          is_user_audio: false,
        };
      })
    );

    dispatch(setSlides(slides));
    showToast("Slides generated successfully");
    if (cb) {
      cb();
    }
  };
